export default {
  profile: {
    welcomeBack: 'Welcome back, {{name}}',
    viewYourShop: 'View your shop',
    customizeYourProfile: 'Customize your profile',
  },
  recentOrders: {
    mostRecentOrders: 'Most recent orders',
    viewAllOrders: 'View All Orders',
    printLabel: 'Print Label',
    getALabel: 'Get a Label',
    addTracking: 'Add Tracking',
  },
  recentOffers: {
    mostRecentOffers: 'Most recent offers',
    viewAllOffers: 'View All Offers',
    offer: 'Offer: ',
    counterOffer: 'Counter offer: ',
    from: 'from {{name}}',
    in: 'in {{address}}',
    expired: 'Expired',
    expires: 'Expires {{time}}',
    respond: 'Respond',
  },
};
